/** Randevu durum sabitleri ve TP teknisyen detay sekmeleri için sınıflandırma */

export const APPOINTMENT_STATUS = {
  COMPLETED: 'Randevu Tamamlandı',
  CANCELLED: 'Randevu İptal Edildi',
  IN_PROGRESS: 'İşlemde',
  WAITING_DATE: 'Randevu Tarihi Bekleniyor',
  WAITING: 'Randevu Bekleniyor',
};

const endOfToday = () => {
  const d = new Date();
  d.setHours(23, 59, 59, 999);
  return d;
};

const startOfToday = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
};

export const getAppointmentDate = (appointment) => {
  if (!appointment?.randevuTarihi) return null;
  const d = new Date(appointment.randevuTarihi);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const isCompletedAppointment = (appointment) =>
  appointment?.durum === APPOINTMENT_STATUS.COMPLETED;

export const isCancelledAppointment = (appointment) =>
  appointment?.durum === APPOINTMENT_STATUS.CANCELLED;

/** Gelecek: tamamlanmamış/iptal değil ve randevu tarihi bugünden sonra */
export const isFutureAppointment = (appointment) => {
  if (isCompletedAppointment(appointment) || isCancelledAppointment(appointment)) {
    return false;
  }
  const aptDate = getAppointmentDate(appointment);
  if (!aptDate) return false;
  return aptDate > endOfToday();
};

/** Açık: tamamlanmamış/iptal değil ve bugün veya geçmiş tarihli (veya tarihsiz bekleyen) */
export const isOpenAppointment = (appointment) => {
  if (isCompletedAppointment(appointment) || isCancelledAppointment(appointment)) {
    return false;
  }
  const aptDate = getAppointmentDate(appointment);
  if (!aptDate) {
    return [
      APPOINTMENT_STATUS.WAITING,
      APPOINTMENT_STATUS.WAITING_DATE,
      APPOINTMENT_STATUS.IN_PROGRESS,
    ].includes(appointment?.durum);
  }
  return aptDate <= endOfToday();
};

export const categorizeAppointments = (appointments = []) => {
  const future = [];
  const open = [];
  const completed = [];

  appointments.forEach((apt) => {
    if (isCompletedAppointment(apt)) {
      completed.push(apt);
    } else if (isFutureAppointment(apt)) {
      future.push(apt);
    } else if (isOpenAppointment(apt)) {
      open.push(apt);
    }
  });

  const sortAsc = (a, b) => {
    const da = getAppointmentDate(a)?.getTime() ?? 0;
    const db = getAppointmentDate(b)?.getTime() ?? 0;
    return da - db;
  };

  const sortDesc = (a, b) => sortAsc(b, a);

  future.sort(sortAsc);
  open.sort(sortAsc);
  completed.sort(sortDesc);

  return { future, open, completed };
};

export const getTechnicianDisplayName = (technician) => {
  if (!technician) return '—';
  const fullName = `${technician.ad || technician.name || ''} ${technician.soyad || technician.surname || ''}`.trim();
  return fullName || technician.kullaniciAdi || '—';
};
